import { findHtmlElement, findNodeList } from '@resources/js/helpers/dom.js'
import {
	normalizeRating,
	getPhraseStringFromRating,
} from '@resources/js/components/hotel-card/helpers/rating-helpers.js'

export const renderHotelCard = (hotel, template) => {
	const templateClone = template.content.cloneNode(true)
	const hotelElement = templateClone.firstElementChild

	// stars
	const starsElement = findHtmlElement('[data-stars]', hotelElement)

	if (hotel.stars > 1) {
		const starElement = findHtmlElement('svg', starsElement).cloneNode(true)
		for (let i = 1; i < hotel.stars; i++) {
			starsElement.appendChild(starElement.cloneNode(true))
		}
	} else {
		starsElement.style.display = 'none'
	}

	// name
	findHtmlElement('[data-name]', hotelElement).textContent = hotel.name

	// photo
	const photoElement = findHtmlElement('[data-photo]', hotelElement)

	const havePhotos = hotel.photos && hotel.photos.length
	// заглушка для локальної розробки
	// if (havePhotos)
	// 	photoElement.src =
	// 		'https://hotelberlin.org/data/images/300x300w/' + hotel.photos[0]

	if (havePhotos)
		photoElement.src = `${location.origin}/data/images/300x300w/${hotel.photos[0]}`

	// address
	const addressElement = findHtmlElement('[data-address]', hotelElement)
	if (hotel.address)
		findHtmlElement('[data-address-text]', addressElement).textContent =
			hotel.address
	else addressElement.style.display = 'none'

	// rating
	const hotelRating = hotel.allInfo?.basic_info?.BcomAvgMark
	const hotelRatingElement = findHtmlElement('[data-rating]', hotelElement)
	const normalizedRating = normalizeRating(hotelRating)

	if (hotelRating && hotelRating > 0)
		hotelRatingElement.textContent = normalizedRating
	else hotelRatingElement.style.display = 'none'

	// review phrase
	const reviewPhraseElement = findHtmlElement('[data-review-phrase]', hotelElement)
	if (hotelRating)
		reviewPhraseElement.textContent = getPhraseStringFromRating(normalizedRating)
	else reviewPhraseElement.style.display = 'none'

	// reviews count
	const reviewsCountElement = findHtmlElement('[data-reviews-count]', hotelElement)
	const isValidReviewCount =
		hotel.allInfo?.basic_info?.BcomReviewCount &&
		hotel.allInfo.basic_info.BcomReviewCount > 0

	if (isValidReviewCount)
		findHtmlElement('span', reviewsCountElement).textContent =
			hotel.allInfo.basic_info.BcomReviewCount
	else reviewsCountElement.style.display = 'none'

	// price
	const priceElements = findNodeList('[data-price]', hotelElement)

	const priceString = hotel.converted_price ? `${hotel.currency_symbol ?? ''} ${hotel.converted_price}` : null

	priceElements.forEach(element => {
		element.textContent = priceString
	})

	// big price
	const bigPriceString = hotel.prices ? `$${Math.round(hotel.price * 1.1)}` : null

	findHtmlElement('[data-big-price]', hotelElement).textContent = bigPriceString

	const datasetValues = {
		bhotelId: hotel.bcomId,
		lat: hotel.geoLat,
		lng: hotel.geoLong,
		price: priceString,
		biggerPrice: bigPriceString,
		stars: hotel.stars || null,
		name: hotel.name,
		photo: photoElement.src,
		rating: normalizedRating,
		reviewPhrase: hotelRating
			? getPhraseStringFromRating(normalizedRating)
			: null,
		reviewsCount: isValidReviewCount
			? hotel.allInfo?.basic_info?.BcomReviewCount
			: null,
	}

	Object.entries(datasetValues).forEach(([key, value]) => {
		if (value) hotelElement.dataset[key] = value
	})

	return hotelElement
}
